import React, { ReactNode, useState } from "react";

interface ExpandingSectionProps {
  title: ReactNode;
  children: ReactNode;
  id: string;
  defaultState?: "open" | "closed";
}

export default function ExpandingSection({
  title,
  children,
  id,
  defaultState = "closed",
}: ExpandingSectionProps): ReturnType<React.FC> {
  const [isOpen, setIsOpen] = useState(defaultState === "open");
  const regionId = `${id}-region`;

  const toggle = () => setIsOpen(!isOpen);

  return (
    <section
      className={`sid-expanding-section sid-expanding-section-${id} sid-l-space-top-sm sid-l-space-btm-sm`}
    >
      <header>
        <button
          aria-controls={regionId}
          aria-expanded={isOpen}
          id={id}
          type="button"
          className="sid-expanding-section__title"
          onClick={toggle}
        >
          <span>{title}</span>
          <div
            className={`sid-expanding-section__indicator sid-expanding-section__indicator--state-${
              isOpen ? "open" : "closed"
            }`}
          />
        </button>
      </header>

      <div id={regionId} role="region" aria-labelledby={id}>
        {isOpen && <div className="sid-expanding-section__children">{children}</div>}
      </div>
    </section>
  );
}
